import { autoserialize, autoserializeAs } from 'cerialize';
import { DocumentTypeStatus } from './document-type-status';
import { TransitProgram } from './transit-program';
import { TransitProgramVehicle } from './transit-program-vehicle';

export class TransitProgramVehicleStatus {
  @autoserializeAs(TransitProgram)
  transitProgram: TransitProgram;

  @autoserializeAs(TransitProgramVehicle)
  transitProgramVehicle: TransitProgramVehicle;

  @autoserialize
  ageRequirementMet: boolean;

  @autoserialize
  requirementsMet: boolean;

  @autoserializeAs(DocumentTypeStatus)
  documentTypeStatuses: Array<DocumentTypeStatus>;
}
